
import React, { memo } from 'react';

import { Dropdown, Image, MenuButton, Icon } from '../../../ui-kit';
import '../styles/_profile-menu.scss';













function goToUrl(history) {
  return ({ value }) => {
    history.push(value);
  };
}

function ProfileMenu(props) {
  const {
    userId,
    handleSignOut,
    history,
    imageUrl,
    fullName,
    isGhosting,
    handleStopGhosting,
    profileMenuContent
  } = props;
  const userEditLink = `/user-settings/edit/${userId}`;
  const pushUrl = goToUrl(history);

  return (
    <div className="profile-menu">
      {isGhosting &&
      <Icon
        className="profile-menu__userprofile-box__icon__ghost"
        name="ghost"
        size={24}
        color="monkey" />}


      <MenuButton
        id="user-profile-dropdown"
        closeAfterClick
        customButton={
        <Image
          width={35}
          height={35}
          imageUrl={imageUrl}
          alt="Organisation Profile"
          circular
          placeholderText={fullName}
          placeholderTextSize={12} />}>



        <div className="profile-menu__container">
          {!profileMenuContent ?
          <>
              <Dropdown.Label
              prefixSize={18}
              data={{ label: 'Manage Profile', prefix: 'user', value: userEditLink }}
              selectOption={pushUrl} />

              {isGhosting &&
            <Dropdown.Label
              prefixSize={18}
              data={{ label: 'Stop Ghosting', prefix: 'ghost', value: userEditLink }}
              selectOption={handleStopGhosting} />}


              <Dropdown.Label
              prefixSize={18}
              data={{ label: 'Sign Out', prefix: 'exit' }}
              selectOption={handleSignOut} />

            </> :
          profileMenuContent}
        </div>
      </MenuButton>
    </div>);

}

export default memo(ProfileMenu);